"use client";

import "dayjs/locale/vi";
import React from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import { viVN } from "@mui/x-date-pickers/locales";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import { MotionLazy } from "@onair/minimal-ui/animate/motion-lazy";

import { ThemeProvider } from "@onair/config-mui";
import { getQueryClient } from "@onair/utils/get-query-client";

const Providers = ({ children }: { children: React.ReactNode }) => {
	const queryClient = getQueryClient();

	return (
		<LocalizationProvider
			dateAdapter={AdapterDayjs}
			adapterLocale="vi"
			localeText={
				viVN.components.MuiLocalizationProvider.defaultProps.localeText
			}
		>
			<ThemeProvider>
				<MotionLazy>
					<QueryClientProvider client={queryClient}>
						{children}
						{process.env.NEXT_PUBLIC_APP_ENV === "development" && (
							<ReactQueryDevtools />
						)}
					</QueryClientProvider>
				</MotionLazy>
			</ThemeProvider>
		</LocalizationProvider>
	);
};

export default Providers;
